type Listener = (...args: unknown[]) => void;

export default class EventEmitter {
    private listeners: Map<string, Set<Listener>> = new Map();

    on(event: string, fn: Listener): this {
        if (!this.listeners.has(event)) this.listeners.set(event, new Set());
        this.listeners.get(event)!.add(fn);
        return this;
    }

    off(event: string, fn?: Listener): this {
        if (!this.listeners.has(event)) return this;
        if (fn) {
            this.listeners.get(event)!.delete(fn);
        } else {
            this.listeners.delete(event);
        }
        return this;
    }

    trigger(event: string, args: unknown[] = []): unknown {
        const set = this.listeners.get(event);
        if (!set) return undefined;
        let last: unknown;
        set.forEach((fn) => {
            last = fn(...args);
        });
        return last;
    }
}
